import { Calendar } from 'antd';
import { T } from '@transifex/react';
import React from 'react';
import moment, { Moment } from 'moment';
import { StyledCalendar } from '../../../../../shared/styles/StyledCalendar';

type CollectionCalendarProps = {
  data: $TSFixMe;
  initialRange: [Moment, Moment];
  location: $TSFixMe;
};

export const BrowserlessCalendar = ({
  data,
  initialRange,
  location,
}: CollectionCalendarProps) => {
  const dateCellRender = (date: Moment) => {
    const listData = data
      ?.flat()
      .filter(
        (e: $TSFixMe) => e.scheduled_at === moment(date).format('YYYY-MM-DD')
      );

    return (
      <div>
        {listData?.map((item: $TSFixMe) => (
          <div className="dot-container">
            <div className="dot" />
            <div className="event-text">
              {item?.container?.waste_fraction?.name}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <StyledCalendar>
      <div className="print-info">
        <div>
          <T _str="Address: {location}" location={location} />
        </div>
        <div>
          <T _str="Printed on: {date}" date={moment().format('LL')} />
        </div>
      </div>
      <div style={{ width: '100%', marginBottom: '1rem' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignContent: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ fontWeight: 800, fontSize: '1.5rem' }}>
            {moment(initialRange?.[0]).format('YYYY MMM')}
          </div>
        </div>
      </div>
      <Calendar
        dateCellRender={dateCellRender}
        style={{ pageBreakAfter: 'avoid', pageBreakInside: 'avoid' }}
        value={moment(data?.[0]?.[0]?.scheduled_at)}
      />
    </StyledCalendar>
  );
};
